import React from 'react'
import Badge from '../ui/Badge'
import { Card } from '../ui/Card'

const rows = [
  ['TEA', 'Antecipação visual, rotina previsível, pistas concretas e mediação sensorial.'],
  ['TDAH', 'Tarefas curtas, reforço imediato, metas pequenas e alternância de estímulos.'],
  ['TOC', 'Baixa sobrecarga, clareza nas regras, acolhimento da rigidez e transições guiadas.'],
  ['Síndrome de Down', 'Concretude, repetição funcional, linguagem acessível e apoio visual.'],
  ['Outros perfis', 'Ajustes individualizados com base na anamnese e no acompanhamento clínico-pedagógico.']
]

export default function SupportMatrix() {
  return (
    <section className="grid cols-2 support-grid">
      <Card>
        <span className="eyebrow">Adaptação pedagógica</span>
        <h2>Neurodiversidade tratada com respeito e planejamento.</h2>
        <p>
          As atividades combinam objetivos curriculares, observação comportamental e suporte concreto com ABA,
          material dourado, jogos estruturados e tecnologias educacionais.
        </p>
      </Card>
      <Card>
        <div className="stack-sm">
          {rows.map(([title, text]) => (
            <div key={title} className="support-row">
              <Badge tone="info">{title}</Badge>
              <p>{text}</p>
            </div>
          ))}
        </div>
      </Card>
    </section>
  )
}
